import { z } from "zod";

export const phoneRegex = /^\(\d{3}\)\s\d{3}-\d{4}$/;

export const addPhoneNumberSchema = z.object({
    idUUID: z.string().nullable().optional(),
    phoneType: z.string().optional().nullable(),
    phoneNumber: z
        .string()
        .nullable()
        .optional()
        .refine((val) => !val || phoneRegex.test(val), {
            message: "If provided, phone number must be in format (XXX) XXX-XXXX",
        }),
    extension: z.string().optional().nullable(),
    primary: z.string().optional().nullable(),
    oK2Call: z.string().optional().nullable(),
    altContactType: z.string().optional().nullable(),
    altContactName: z.string().optional().nullable(),
});
